module.exports = __webpack_public_path__ + "static/dieti-natura-ceea19f222264259ff89b2d66bb803ff.jpg";